import Vue from 'vue'
import App from './App'
import router from './router'
import axiosApi from 'axios'
import api from './api'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

export const eventBus = new Vue({
  data: {
  },
  methods: {
    changeAge (age) {
      this.$emit('ageWasEdit', age)
    }
  }
})

const axios = axiosApi.create({
  baseURL: "",
  headers: ""
})
window.axios = axios;
window.api = api;

//Setting biến toàn cục
Vue.prototype.settings = {
  prefixSong: "/bai-hat/",
  prefixSinger: "/nghe-si/",
  prefixAlbum: "/album/",
  prefixNews: "/giai-tri/",
  defaultThumbnailSong: "../../../static/img/icon-music.png",
  defaultThumbnailBigSong: "../../static/img/icon-music-2.png",
  defaultThumbnailAlbum: "../../static/img/icon-music-3.png",
  orderByYouMayLike: 1,
  categoryCodeGuide: "HD",
  //giftAlert: 'Để tặng bài hát nhạc số quà tặng âm nhạc soạn:<br/> <strong style=\'font-weight: bold;\'>BH songcode [SĐT_nhận] </strong> GỬI <strong style=\'font-weight: bold;\'>1082</strong><br/>Để tặng bài hát nhạc chờ soạn: <br/><strong style=\'font-weight: bold;\'>TANG [mã_số_nhạc_chờ] [SĐT_nhận]</strong> GỬI <strong style=\'font-weight: bold;\'>1082</strong>',
  giftAlert: 'Để tặng bài hát nhạc số quà tặng âm nhạc soạn:<br/> <strong style=\'font-weight: bold;\'>BH songcode [SĐT_nhận] </strong> GỬI <strong style=\'font-weight: bold;\'>1082</strong>',
  downloadAlert: 'Để cài đặt bài hát làm nhạc chờ vui lòng soạn:<br/> <strong style=\'font-weight: bold;\'>CHON songcode</strong> GỬI <strong style=\'font-weight: bold;\'>1082</strong>',
  loginAlert: "Vui lòng đăng nhập hoặc đăng ký để xem nội dung",
  modalTitle: "Thông báo",
  noSongAlert: "Không có bài hát nào",
  installRingbacktoneAlert: "Mã nhạc chờ đang được cập nhật",
  updating: "Updating..."
};
Vue.prototype.checkIsMobile = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}
Vue.prototype.getParamUrl = function (sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};
Vue.prototype.convertToAlias = function(alias){
  var str = alias;
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y");
  str = str.replace(/đ/g,"d");
  str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
  str = str.replace(/ + /g," ");
  str = str.replace(/ /g, "-");
  str = str.trim();
  return str;
};
Vue.prototype.subString = function(source, size){
  return source.length > size ? source.slice(0, size - 1) + "…" : source;
}
Vue.prototype.modalShow = function(){
  $("#vmodal").modal("show");
}
Vue.prototype.checkLogin = function(login){
  if(login == "1"){
    //Phải đăng nhập mới xem được tin
    if(!this.$session.exists()){
      //Chưa đăng nhập
      return false
    } else {
      if(this.$session.has("isRegisted") && this.$session.get("isRegisted") == false){
        //Chưa đăng ký gói dịch vụ
        return false;
      } else {
        //Đã đăng nhập và đăng ký gói dịch vụ
        return true;
      }
    }

  } else if(login == "0") {
    //Không cần đăng nhập vẫn xem được tin
    return true;
  }
}
Vue.prototype.redirectTo = function(value){
  if(!value){
    this.modalShow();
  }
}

Vue.config.productionTip = false

//Khai báo component dùng chung
import MostSinger from './components/home/web/MostSinger'
import Modal from './components/Modal'
Vue.component('most-singer', MostSinger)
Vue.component('modal', Modal)

//Khai báo Vue
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js